import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Clase } from 'src/app/Models/clase/clase';
import { SubClase } from 'src/app/Models/subclase/sub-clase';
import { SubGrupo } from 'src/app/Models/subgrupo/sub-grupo';
import { UnidadMedida } from 'src/app/Models/unidadmedida/unidad-medida';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ClaseComponent } from '../../clase/clase/clase.component';
import { SubClaseComponent } from '../../subclase/sub-clase/sub-clase.component';
import { SubGrupoComponent } from '../../subgrupo/sub-grupo/sub-grupo.component';
import { CatalogoProducto } from 'src/app/Models/catalogoproducto/catalogo-producto';
import { CatalogoProductoComponent } from '../../catalogoproducto/catalogo-producto/catalogo-producto.component';
import { Precio } from 'src/app/Models/precio/precio';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Zona } from 'src/app/Models/zona/zona';
import { async } from '@angular/core/testing';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { UnidadMedidaComponent } from '../../unidad/unidad-medida/unidad-medida.component';
import { AfectoIgv } from 'src/app/Models/afectoigv/afecto-igv';
import { TipoExistencia } from 'src/app/Models/tipoexistencia/tipo-existencia';

@Component({
    selector: 'app-articulo-edit',
    templateUrl: './articulo-edit.component.html'
})
export class ArticuloEditComponent implements OnInit {

    @ViewChild('btnshowart', null) btnshowart: ElementRef;
    @ViewChild('btncloseart', null) btnclosepg: ElementRef;
    @ViewChild('artloading', null) artloading: LoadingComponent;
    @ViewChild('artinfo', null) artinfo: InfoComponent;
    @ViewChild(ClaseComponent, null) fmclase: ClaseComponent;
    @ViewChild(SubClaseComponent, null) fmsubclase: SubClaseComponent;
    @ViewChild(SubGrupoComponent, null) fmsubgrupo: SubGrupoComponent;
    @ViewChild(CatalogoProductoComponent, null) fmcatalogoproducto: CatalogoProductoComponent;
    @ViewChild(UnidadMedidaComponent, null) fmunidad: UnidadMedidaComponent;
    public articulo: Articulo = new Articulo();
    public articulos:Articulo[]=[];
    public clases: Clase[] = [];
    public subclases: SubClase[] = [];
    public subgrupos: SubGrupo[] = [];
    public unidades: UnidadMedida[] = [];
    public catalogo:CatalogoProducto[]=[];
    public afectos:AfectoIgv[]=[];
    public funcion: Function;
    public funcion_update: Function;
    public isShow: boolean = false;
    public papprecio:any;
    public waitclase: boolean = false;
    public waitsubclase: boolean = false;
    public waitsubgrupo: boolean = false;
    public waitunidad : boolean = false;
    public waitcatalogo : boolean = false;
    public waitafecto : boolean = false;
    public codigo: string = "";
    public iscreated: boolean = false;
    public iseditable: boolean = false;
    public tipos_existencias: TipoExistencia[]=[]
    public precios:Precio[]=[];
    public precio:Precio = new Precio();
    public monedas:Moneda[]=[];
    public preciosE:Precio[]=[];
    public cantprecios:number=0;
    public zonas:Zona[]=[];
    public submitted: boolean = false;
    public ischange:boolean = false;
    public lbltitulo:string='';
    public hasimpto_cbp:string = '0'
    public tipoproductos:any[] = [{codigo:'ART',nombre:'ARTÍCULO'},{codigo:'SER',nombre:'SERVICIO'},{codigo:'DES',nombre:'DESACTIVA'}];
    constructor(private data: DataService, private notify: NotifyService) { }
    ngOnInit() {

    }
    public show(affterfunction: Function = null, fupdate: Function = null) {
        
        this.funcion = affterfunction;
        this.funcion_update = fupdate;
        this.isShow = true;
        this.lbltitulo = this.iseditable ? 'Modificar Articulo CD:' + this.articulo.codigo : 'Crear Nuevo Articulo';
        setTimeout(async () => {
            this.btnshowart.nativeElement.click();
            this.artloading.show('Cargando datos');
            
            await this.GetArticulo();
            await this.GetClase();
            await this.GetSubClase();
            await this.GetSubGrupo();
            await this.GetUnidadMedida();
            await this.GetMoneda();
            await this.GetAfectoIGV();
            await this.GetTipoExistencia();
            this.GetZona();
            if (this.iseditable) {
                await this.GetPrecios(); // carga los precios asignados

            } else {
               this.precios = []
               
            }
            this.artloading.hide();
            this.ischange=true;
        }, 10);

    }


    close() { this.btnclosepg.nativeElement.click(); }
    async GetArticulo() {
        await this.data.AsyncGetSimple(this.data.api.articulos).then(r => {
            this.articulos = r;
        }).catch(e=>{console.log(e.error.text)});
    }
    async GetClase() {
        this.waitclase = true;

        await this.data.AsyncGetSimple(this.data.api.clase).then(r => {
            this.clases = r;
            this.waitclase= false;
        }).catch(e=>{console.log(e.error.text)});
    }
    async GetSubClase() {
        this.waitsubclase= true;
        let idclase:string = this.articulo.idclase.idclase != undefined  ? this.articulo.idclase.idclase : "0";
        console.log(idclase);
        
        await this.data.AsyncGetFromValue(this.data.api.subclase, 'idclase', idclase).then(r => {
            console.log(r);
            
            this.subclases = r;
            this.waitsubclase= false;
            
        }).catch(e=>{console.log(e.error.text);});
    }
    async GetSubGrupo() {
        this.waitsubgrupo = true;
        this.subgrupos=[];
        let idsubclase:string = this.articulo.idsubcla.idsubcla != undefined ? this.articulo.idsubcla.idsubcla : "0";
        console.log(idsubclase);
        await this.data.AsyncGetFromValue(this.data.api.subgrupo,'idclase',idsubclase).then(r => {
            this.subgrupos = r;
            this.waitsubgrupo= false;
        }).catch(e=>{console.log(e.error.text)});
    }

    ChangeClase(){
        this.articulo.idsubcla.idsubcla = null;
        this.articulo.clase3.idgrupo = null;
        this.subclases=[];
        this.subgrupos=[];
        this.GetSubClase();
    }
    ChangeSubClase(){
        this.articulo.clase3.idgrupo = null;
        this.subgrupos=[];
        this.GetSubGrupo();
    }


    async GetUnidadMedida(){
        this.waitunidad= true;
        await this.data.AsyncGetSimple(this.data.api.unidadmedida).then(r=>{
            this.unidades = r;
            this.waitunidad= false;
        }).catch(e=>{console.log(e.eror.text)});
    }
    
    async GetAfectoIGV(){
        this.waitafecto= true;
        await this.data.AsyncGetSimple(this.data.api.afectoigv).then(r=>{
            this.waitafecto = false;
            this.afectos = r;
            console.log(this.afectos);
            
        }).catch(e=>{console.log(e.eror.text)});
    }

    async GetTipoExistencia(){
        this.waitafecto= true;
        await this.data.AsyncGetSimple(this.data.api.tipoexistencia).then(r=>{
            this.waitafecto = false;
            this.tipos_existencias = r;
            console.log(this.tipos_existencias);
            
        }).catch(e=>{console.log(e.eror.text)});
    }
    async GetProductoId(code){
        await this.data.selectP(this.data.api.articulos,'codigo',this.articulo.codigo).then(r=>{

        });
    }
    async GetMoneda(){
        await this.data.AsyncGetSimple(this.data.api.moneda).then(r=>{
            console.log("monedas");
            console.log(r);
            this.monedas= r;
        }).catch(e=>{console.log(e.error.text)})
    }
    async GetZona(){
        await this.data.AsyncGetSimple(this.data.api.zona).then(r=>{
            this.zonas= r;
            console.log("zonas: ",this.zonas);
            
        }).catch(e=>{console.log(e)});
    }



    /* cargar los precios asignados al producto */
    async GetPrecios(){
        await this.data.AsyncGetFromValue(this.data.api.precio,'idproduct',this.articulo.idproduct).then(r=>{            
            
            this.precios = r;
            console.log(r);
            
            let pr:Precio[]=[];
            this.countp=0;
            if(this.precios.length > 0){
                for (let item of this.precios) {
                    
                    item.preventa = parseFloat(item.preventa.toString()).toFixed(2);
                    item.impuesto = parseFloat(item.impuesto).toFixed(6);
                    item.valvta = parseFloat(item.valvta).toFixed(6);
                    item.igv = parseFloat(item.igv).toFixed(2);
                    item.codbar = item.codbar!=undefined? item.codbar.trim():'';
                    item.n = this.countp.toString();
                    this.countp++;
                    pr.push(item);
                }
                this.precios = pr;
                this.cantprecios =  this.precios.length;
            }else{
                this.precios = [];
                this.cantprecios = 0;
            }
                

            
            
        }).catch(e=>{console.log(e)});
    }
    
    UpdateImpto_cbp(event: Event) {
        this.articulo.impto_cbp = (event.target as HTMLInputElement).checked ? '1' : '0';
        console.log(this.articulo);
        
      }

    
    /* agregar nuevo precio */
    AddPrecio(){
        if(this.cantprecios >=0){
            let ps:Precio[]=[];
            let p:Precio = new Precio();
            for (let i = 0; i < this.cantprecios; i++) {
                ps.push(this.precios[i]);
            }
            p.idproduct.idproduct = this.articulo.idproduct;
            ps.push(p);

            this.precios = ps;
        }
    }


    GenereCodigo(){
        let circle:boolean = true;
        let n:number = 1;
        do {
            let firt:string = this.articulo.idclase.idclase.toString().padStart(3,'0');
            let last:string = this.articulo.clase3.idgrupo.toString().padStart(3,'0');
            let cd:string = firt + last + n.toString().padStart(4,'0');
            console.log(n);
            
            if(this.articulos.find(e=>e.codigo == cd) == undefined){
                circle=false;
                this.articulo.codigo= cd;
            }
            n++;
        } while (circle);
    }

    validateAfectoIGV(){
        if (this.articulo.afectoigv ==='8' || this.articulo.afectoigv==='9') {
            this.precios.forEach(precio => {
                precio.igv='0.00'
            });
        }else{
            this.precios.forEach(precio => {
                precio.igv='18.00'
            });
        }
    }

    VailidateCodeButton():boolean{
        return (this.articulo.idclase != undefined && this.articulo.idsubcla!=undefined && this.articulo.clase3 != undefined)? true:false;
    }

    ShowClase(){
        this.fmclase.show(()=>{
            
            this.GetClase().then(()=>{
                this.articulo.idclase=this.fmclase.claseres
                console.log(this.articulo);
            });
            
        });
    }
    ShowSubClase(){
        this.fmsubclase.show(()=>{
            this.GetSubClase().then(()=>{
                this.articulo.idsubcla=this.fmsubclase.subclaseres
                console.log(this.articulo);
            });
        });
    }
    ShowSubGrupo(){
        this.fmsubgrupo.show(()=>{this.GetSubGrupo();});
    }
    ShowCatalogoProducto(){
        this.fmcatalogoproducto.show(()=>{this.articulo.codigo_fe = this.fmcatalogoproducto.catalogo.codigo.toString();});
        
    }
    ShowUnidadMedida(){
        this.fmunidad.show(()=>{this.GetUnidadMedida();});
    }

    validarNombre(){return this.submitted && this.articulo.nombre}
    validarCodigo(){return this.submitted && this.articulo.codigo}
    validarSubclase(){return this.submitted && this.articulo.idsubcla.idsubcla}
    validarSubgrupo(){return this.submitted && this.articulo.clase3.idgrupo}

    public isaddprecio():string{
        let res:boolean = false;
        if(this.data.isset(this.articulo.codigo) && this.articulo.idclase != undefined && this.articulo.idsubcla != undefined && this.articulo.clase3 != undefined && this.articulo.unidad != undefined && /*this.articulo.catalogoproducto.codigo != undefined  && */this.data.isset(this.articulo.tipo_exis) && this.data.isset(this.articulo.nombre) && this.data.isset(this.articulo.afectoigv) ){
            res = true;
        }
        if(!res){ return 'true'; }
    }
    async SaveItem(){
        if(this.iseditable){//modificar
            
            let data:Articulo =  new Articulo()

            data.idproduct = this.articulo.idproduct,
            data.codigo = this.articulo.codigo,
            data.nombre = this.articulo.nombre,
            data.modelo = this.articulo.modelo,
            data.marca = this.articulo.marca,
            data.idprovee = this.articulo.idprovee,
            data.codpro = this.articulo.codpro,
            data.pais = this.articulo.pais,
            data.stockmini = this.articulo.stockmini,
            data.stockmax = this.articulo.stockmax,
            data.valvta = this.articulo.valvta,
            data.moneda = this.articulo.moneda,
            data.tipo = this.articulo.tipo,
            data.moncosto = this.articulo.moncosto,
            data.igv = this.articulo.igv,
            data.costopro = this.articulo.costopro,
            data.ultcosto = this.articulo.ultcosto,
            data.utilipor = this.articulo.utilipor,
            data.tcambio = this.articulo.tcambio,
            data.personalc_id = this.articulo.personalc_id,
            data.personalm_id = this.articulo.personalm_id,
            data.igvt = this.articulo.igvt,
            data.total = this.articulo.total,
            data.pesouni = this.articulo.pesouni,
            data.color = this.articulo.color,
            data.flete = this.articulo.flete,
            data.stockmin = this.articulo.stockmin,
            data.otrocosto = this.articulo.otrocosto,
            data.tipo_exis = this.articulo.tipo_exis,
            data.otros = this.articulo.otros,
            data.saldo00001 = this.articulo.saldo00001,
            data.saldo00002 = this.articulo.saldo00002,
            data.dtmodificacion = this.articulo.dtmodificacion,
            data.codsunat = this.articulo.codsunat,
            data.atributo = this.articulo.atributo,
            data.s_image = this.articulo.s_image,
            data.n_image = this.articulo.n_image,
            data.afectoigv = this.articulo.afectoigv,
            data.codigo_fe = this.articulo.codigo_fe,
            data.impto_cbp = this.articulo.impto_cbp,
            data.idclase = this.articulo.idclase,
            data.idsubcla = this.articulo.idsubcla,
            data.clase3 = this.articulo.clase3,
            data.unidad = this.articulo.unidad
            console.log(data.GetData());
            
            this.artloading.show('modificando datos');
            await this.data.AsyncPut(this.data.api.articulos,this.articulo.idproduct,data.GetData()).then( async a=>{
                console.log(a);
                this.close();
                if(a.status == 'success'){
                    for (let precio of this.precios) {
                        console.log(precio);
                        if(precio.idprecio != undefined){
                            console.log("Actualizando precio: ",precio);
                            
                            await this.data.AsyncPut(this.data.api.precio,precio.idprecio,precio).then(r=>{
                                console.log(r);
                            }).catch(e=>{console.log(e.error);});
                        }else{
                            console.log("Guardando nuevo precio precio: ",precio);
                            precio.idproduct.idproduct = this.articulo.idproduct;
                            await this.data.AsyncPost(this.data.api.precio,precio.GetData()).then(async b =>{
                                console.log(b);
                            }).catch(e=>{console.log(e.error.text)});
                        }
             
                    }
                    this.GetPrecios();
                    if(this.funcion != undefined){this.funcion();}
                    
                }
            }).catch(e=>{console.log(e);}) ;
            

        }else{//insert new
            this.artloading.show('registrando Nuevo');
            await this.data.AsyncPost(this.data.api.articulos,this.articulo.GetData()).then( async a=>{
                console.log(a);
                
                if(a.message == 'success'){
                    console.log(this.precios);
                    
                    for (let precio of this.precios) {
                        console.log(precio);
                        precio.idproduct.idproduct = a.data.idproduct;
                        console.log(precio.idproduct.idproduct);
                        
                        await this.data.AsyncPost(this.data.api.precio,precio.GetData()).then(async b =>{
                            console.log(b);
                        }).catch(e=>{console.log(e)});
                    }
                    if(this.funcion != undefined){this.funcion();}
                }
            }).catch(e=>{console.log(e);}) ;
            this.close();
            this.artloading.hide();
        }
    }

    validar(){
        this.submitted = true;
    }
    
    /* GENERE PRECIO DETALLES*/
    public countp:number=0;
    genereprecio(){
        let pr:Precio[]=[];
        this.countp=0;
        if(this.precios.length > 0){
            for (let item of this.precios) {
                item.preventa = item.preventa != undefined ? parseFloat(item.preventa).toFixed(2) : null;
                item.impuesto = item.impuesto != undefined ? parseFloat(item.impuesto).toFixed(6) : null;
                item.valvta = item.valvta != undefined ? parseFloat(item.valvta).toFixed(6) : null;
                item.igv = item.igv != undefined ? parseFloat(item.igv).toFixed(2) : '18.00';
                item.codbar = item.codbar != undefined ? item.codbar.trim() : null;
                item.n = this.countp.toString();
               // item.igv = '18';
                this.countp++;
                pr.push(item);
            }
        }
        let p:Precio = new Precio();
        p.n = this.countp.toString();
        p.codbar = "";
        p.igv=this.articulo.afectoigv==='8' ||this.articulo.afectoigv==='9' ?'0.00':'18.00';
        pr.push(p);
        
        this.precios = pr;
    }
    KeyupValVta(i){
        this.precio = this.precios[i];
        this.precio.impuesto = ((+this.precio.igv/100) * (+this.precio.valvta)).toFixed(6).toString();
        this.precio.preventa = (((+this.precio.igv/100) * (+this.precio.valvta)) +  (+this.precio.valvta)).toFixed(2).toString();
    }
    ChangeValVta(i){
        this.precio = this.precios[i];
        this.precio.valvta = (+this.precio.valvta).toFixed(6);
    }
    KeyupPrecio(i){
        this.precio = this.precios[i];
        this.precio.valvta = ((+this.precio.preventa) / (1 + (+this.precio.igv/100))).toFixed(6).toString();
        this.precio.impuesto = ((+this.precio.igv/100) * (+this.precio.valvta)).toFixed(6).toString();    
    }
    
    ChangePrecio(i){
        this.precio = this.precios[i];
        this.precio.preventa = (+this.precio.preventa).toFixed(2);
    }

    async DeleteItem(i){
        this.precio = this.precios[i];
        if(this.precio.idprecio == undefined){
            this.precios.splice(i,1);
            this.countp--;
        }else{
            
            this.data.notify('Estimado usuario, ¿Estas seguro de eliminar el precio seleccionado del sistema?','Eliminar precio',this.data.alertType.question,new ALertOption(true,true),async ()=>{
                /* eliminar precio */
               await this.data.AsyncDelete(this.data.api.precio,this.precio.idprecio).then((r)=>{
                   console.log(r);
                   if(r.status === "success"){
                     this.data.notify(r.message,'Proceso exitoso',this.data.alertType.success,new ALertOption(false,true,'Aceptar'));
                   }else{
                    this.data.notify(r.message,'Error al eliminar',this.data.alertType.error,new ALertOption(false,true,'Aceptar'));
                   }
                    this.GetPrecios();
                }).catch((e)=>{console.log(e.error)});
            });
        }
        
    }

    autoorder(){
        let pr:Precio[]=[];
        this.countp=0;
        for (let item of this.precios) {
            this.countp++;
            item.n = this.countp.toString();
            item.igv = '18';
            pr.push(item);
            
        }
        this.countp++;
        let p:Precio=new Precio();
        p.n = ( this.countp - 1).toString();
        p.igv='18';
        pr.push(p);
        this.precios = pr;
    }
}
